<template>
  <v-card flat class="overflow-hidden top-card" id="first">


   <v-navigation-drawer
      fixed
      v-model="drawer"
      temporary
      hide-overlay
      left
      app
      :width="$vuetify.breakpoint.xs?'80%':'18%'"
      color="rgba(255,255,255,1.0)"      
      @transitionend="endTrans"
      class="drawer-inn"
      
    >
    <div class="px-5 pt-3"   >
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="5.5" contain></v-img>
    </div>
              <v-row  justify="start" align="center" class="ml-1 mt-2 mx-0"> 
              <v-col cols="1" class="py-0 my-0">
                    <v-btn class="my-0" tile text color="black"  v-show=" drawer" @click.stop="drawer = !drawer" >
                      <v-icon left>mdi-close</v-icon>
                    </v-btn>
              </v-col> 
              </v-row>
      <v-list dense >
        <span :key="`mnu-`+i" v-for="(itm, i) in drawerMenu">
          
                <v-list-item link  @click.stop='goToPage(itm)' class="item-mnu-drw">

                  <v-list-item-content :class="{ active: currItemMenu === itm.url.toString() }">
                    <v-list-item class="text-left title" color="black">{{itm.title}}</v-list-item>
                  </v-list-item-content>
                </v-list-item>

        </span>
      </v-list>

    </v-navigation-drawer>


    <AppBarInner :titleBarInner="titleInnert" v-if="$vuetify.breakpoint.smAndUp"/>
    <AppBarInnerMob :titleBarInner="titleInnert" v-if="$vuetify.breakpoint.xs"/>




    <v-sheet id="scrollT" class="overflow-y-auto" max-height="100vh">
      <v-main id="tscroll" class="overflow-y-auto main-pad">
        <v-row justify="start" class="ma-0 pa-0">
          <v-col cols="12" sm="12" md="3" lg="3" xl="2" class="pa-0 ma-0">
            <SideMenu v-if="$vuetify.breakpoint.smAndUp" />
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" xl="10" class="pa-0">
            <v-row id="trig" class="ma-0 pa-0">
              <Breadcrumbs />
            </v-row>
            <v-row
              justify="center"
              align="center"
              class="pa-0 ma-0 dff1"
              v-scroll:#first="onScroll"
            >
              <v-col cols="12" class="pa-0">
                <router-view />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-main>
    <Footer v-if="$vuetify.breakpoint.smAndUp"/>  
    <FooterMob v-if="$vuetify.breakpoint.xs"/>  
    </v-sheet>




  </v-card>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "vue-router";

import Breadcrumbs from "@/components/Breadcrumbs";
import SideMenu from "@/components/SideMenu";
import Footer from "@/components/Footer";
import FooterMob from "@/components/FooterMob";
import AppBarInner from "@/components/AppBarInner";
import AppBarInnerMob from "@/components/AppBarInnerMob";
import SwiperSEO from "@/components/SwiperSEO";

Vue.use(Vuex);

export default {
  name: "InsidePage",
  components: {
    Breadcrumbs,
    SideMenu,
    AppBarInner,
    AppBarInnerMob,
    Footer,
    FooterMob,
    SwiperSEO,
  },
  data() {
    return {
      fixed: false,
      offsetTop: 0,
      icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
      seoInfo: {
        content:
          "На первом месте — информация, полезная покупателю при выборе и покупке товара. Тексты категорий раскрывают особенности, недостатки и достоинства продуктов этой линии. Содержат советы для выгодных приобретений и никак не являют собой набор несвязных фраз, сгенерированных из ключевых слов.<br/>\
Вторая по значимости функция — обеспечение релевантности поисковому запросу. Текст категории товара, как и все другие на сайте, должен содержать разумное вхождение основного ключевика, перемежаемого синонимами и тематическими словами из LSI-ядра. Языковые конструкции строятся естественным образом, чтобы текст легко читался и не имел ничего общего с плохим классическим SEO-текстом.<br/>\
Третье назначение текстов категорий — повышение конверсии. В них можно «зашить» информацию о выгодных ценах на линейку товара, причем указать конкретные цифры (скидка 20%, бесплатная доставка по городу и т. п.). Или указать, что вся продукция упакована настолько компактно, что вы можете сами увезти и то, и это на вашем седане. То есть нужно написать что-то такое, что побудит посетителя пойти дальше к карточкам товаров, заказать обратный звонок, написать в онлайн-чат или выполнить другое конверсионное действие.",
        gallery: [
          "https://picsum.photos/1600/1200?random12",
          "https://picsum.photos/1600/1200?random22",
          "https://picsum.photos/1600/1200?random13",
          "https://picsum.photos/1600/1200?random7",
          "https://picsum.photos/1600/1200?random17",
        ],
      },
    };
  },

  /*     metaInfo: {
      title: "Магазины - ",
    meta: [
      {  name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]

    }, */

  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    pages: {
      get () {
          let vApp = this;
          return vApp.$store.state.pages.allPages;
      },
    },
    currItemMenu: {
      get() {
        return this.$store.state.menu.currItemMenu;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setCurrentMenu", val);
      },
    },
    sideMenu: {
      get() {
        return this.$store.state.menu.menu;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateMenu", val);
      },
    },
    titleInnert: {
      get() {
        let vApp = this;
      if(vApp.isDebug)   if(DEBUG) console.log(
          "this.$store.state.category :",
          this.$store.state.app.titleInner
        );
        return this.$store.state.app.titleInner;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setTitleInner", val);
      },
    },
    drawer: {
      get() {
        return this.$store.state.menu.drawer;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateDrawer", val);
      },
    },
    drawerMenuHome: {
      get() {
        let vApp = this;
        return vApp.$store.state.menu.menuh;
      },
    },
    drawerMenu: {
      get() {
        let vApp = this;
        return vApp.$store.state.menu.menu;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateMenu", val);
      },
    },
  },
  methods: {
      endTrans(){
    if(vApp.isDebug)   if(DEBUG) console.log( "            <<<<<<<<<<<< МЕНЮ ЗАКРЫЛОСЬ или ОТКРЫЛОСЬ >>>>>>>>>>>>" )
      },
      goToPage (itemMnu) {
        let vApp = this
        vApp.drawer = false
        if(vApp.isDebug)  if(DEBUG) console.log(' gotoPAGE url :>> ', itemMnu.url)
         
         
        setTimeout(function() {
            if(itemMnu.url == '/'){
              vApp.$router.push('/')
            }
            else{          
          if (vApp.$route.path !== itemMnu.url){
           
          if(vApp.isDebug)   if(DEBUG) console.log(' gotoPAGE ID :>> ', itemMnu.id)
            if(itemMnu.id < 12) {
            vApp.currItemMenu = itemMnu.url
             vApp.$router.push('/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
             
             }
             else{
              if(vApp.isDebug)  if(DEBUG) console.log('vApp.pages :>> ',vApp.pages)
              if(vApp.isDebug)  if(DEBUG) console.log(' currItemMenu :>> ', itemMnu.url.split('/'))
              const getPageInfo = vApp.pages.find(fpi=>fpi.slug === itemMnu.url)
               vApp.currItemMenu = itemMnu.url
               //vApp.currItemMenu = itemMnu.url.split('/')[1]
              if(vApp.isDebug)  if(DEBUG) console.log('GoTo Single Page :>> ',getPageInfo)
                vApp.$router.push('/page/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
               
             }
             }
             }

        }, 500);


      },

/*       
    goToPage (url) {
      let vApp = this;
      vApp.drawer = false;
    if(vApp.isDebug)   if(DEBUG) console.log('url :>> ', url);
      if (url==='//') {
        url='/'
      }
      vApp.currItemMenu = url.split('/')[1];
      vApp.$router.push(url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    }, */

    onScroll(e) {
      let vApp = this;
    if(vApp.isDebug)   if(DEBUG) console.log("e Scrollingis Intersecting :", e[0]);
    if(vApp.isDebug)   if(DEBUG) console.log("e Scrollingis Intersecting :", e[0].isIntersecting);
      //  vApp.offsetTop = e.target.scrollTop;
    },
  },
  mounted() {
    let vApp = this;
  if(vApp.isDebug)   if(DEBUG) console.log("mounted Inside Page ");

    vApp.$nextTick(function () {
      let getHTML = document.documentElement;
    if(vApp.isDebug)   if(DEBUG) console.log("getHTML :", getHTML);
      getHTML.setAttribute("style", "overflow: hidden;");
      /*       let scrollEl = document.querySelector('#scrollT');
      let targetEl = document.querySelector('#trig');

      scrollEl.addEventListener('scroll', function() {
        
      if(vApp.isDebug)   if(DEBUG) console.log('scrollEl :', scrollEl.scrollTop );
      }); */

      /*       let options = {
        root: document.querySelector('#first'),
        rootMargin: '0px 0px 300px 0px',
        threshold:  [0]
      }
      let observer = new IntersectionObserver(vApp.onScroll, options);
      let target = document.querySelector('#trig');
      observer.observe(target); */
    });
  },
};
</script>
<style  scoped>

.drawer-inn{
  z-index: 1500;
}
.item-mnu-drw{
  height: 30px;
}
.active{
  text-decoration: underline;
}
.main-pad{
  padding-bottom: 30px;
}
</style>